// extracted by mini-css-extract-plugin
export default {"travel-risk-about":"AboutSXReport_travel-risk-about__B4Vum","info-title":"AboutSXReport_info-title__kejQS","info-text":"AboutSXReport_info-text__91xgR"};